import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Add, Email } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Autocomplete, Button, Checkbox, Fab, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import CheckboxItem from 'app/shared/widgets/WeeklySales/components/CheckboxItem';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ShoppingCartCheckoutSharpIcon from '@mui/icons-material/ShoppingCartCheckoutSharp';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import StoneTableViewWIthAGRFormat from 'app/shared/StoneTableViewWIthAGRFormat';
import ExcelGenerateForSearch from 'app/shared/ExcelGenerate';
import ExcelGenerate, { ExcelGenerateAdmin } from 'app/shared/ExcelGenerate/ExcelGenerateForSearch';
// import { DataGrid } from '@mui/x-data-grid';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DataGrid } from '@mui/x-data-grid';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';
// const columns = [
//   { field: 'id', headerName: 'ID', width: 70 },
//   { field: 'firstName', headerName: 'First name', width: 130 },
//   { field: 'lastName', headerName: 'Last name', width: 130 },
//   {
//     field: 'age',
//     headerName: 'Age',
//     type: 'number',
//     width: 90,
//   },
//   {
//     field: 'fullName',
//     headerName: 'Full name',
//     description: 'This column has a value getter and is not sortable.',
//     sortable: false,
//     width: 160,
//     valueGetter: (params) =>
//       `${params.row.firstName || ''} ${params.row.lastName || ''}`,
//   },
// ];

// const rows = [
//   { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//   { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
//   { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
//   { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//   { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//   { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//   { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//   { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//   { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
// ];


export default function SearchResultUser({data,searchForm,fallBack = null}) {
  const [SearchData, setSearchData] = useState(data)
  // const { searchid } = useParams()
  const [Stoneresultdata, setStoneresultdata] = useState(data)
  const [userParty, setUserParty] = useState(null)
  const [selectedStoneDetails, setSelectedStoneDetails] = useState({ pcs: 0, cts: 0, rap: 0, disc: 0 })
  const [userSelectedParty, setUserSelectedParty] = useState(null)
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState([50,100,500,1000]);
  const [SelectedStone, setSelectedStone] = useState([])
  const [SelectedStoneData, setSelectedStoneData] = useState([])
  const [BLOADER, setBLOADER] = useState(false)
  const swal = useSwalWrapper();
  const jumboco = useJumboAuth();
  const isMobile= isMobileDevice()
  const navigate = useNavigate()
  const columns = [
    // { field: 'PARTY', headerName: 'Party', width: 70 ,headerClassName: 'TopHeader', renderCell: (params) => ( params.value == ' ()'?'-' :params.value )},
    { field: 'STATUS', headerName: 'Status', width: 40,renderCell:(params)=>params.value[0] ||'' },
    { field: 'STONE', headerName: 'StoneId', width: 100 },
    { field: 'LAB', headerName: 'Lab', width: 10 },
    { field: 'REPORTNO', headerName: 'ReportNO', width: 100 },
    { field: 'SHAPE', headerName: 'Shape', width: 120 },
    { field: 'CARATS', headerName: 'Carats', width: 80, renderCell: (params) => (
      Number(params.value).toFixed(2)
    ) },
    { field: 'COLOR', headerName: 'Color', width: 50 },
    { field: 'CLARITY', headerName: 'Clarity', width: 60 },
    { 
      field: 'ASK_DISC_AMTRmB', 
      headerName: 'AMT(RMB)', 
      width: 100, 
      valueGetter: (params) =>
      `${(jumboco?.curr?.Rate *((Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.ASK_DISC / 100)) * params.row.CARATS)).toFixed(2)}`,
      // cellClassName: classes.ASkCell
    },
    { 
      field: 'RAP_PRICE', 
      headerName: 'Rap($)', 
      width: 100,
      renderCell: (params) => (
        Number(params.value).toFixed(2)
      )
    },
    { 
      field: 'ASK_DISC', 
      headerName: 'Disc(%)', 
      width: 60, 
      renderCell: (params) => (
        Number(params.value)?.toFixed(2)
      ),
      // cellClassName: classes.ASkCell
    },
    { 
      field: 'ASK_DISC_PER_CTS', 
      headerName: 'AMT/CTS($)', 
      width: 100, 
      renderCell: (params) => (
        ((Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.ASK_DISC / 100)))?.toFixed(2)
      ),
      // cellClassName: classes.ASkCell
    },
    { 
      field: 'ASK_DISC_AMT', 
      headerName: 'AMT($)', 
      width: 100, 
      renderCell: (params) => (
        ((Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.ASK_DISC / 100)) * params.row.CARATS)?.toFixed(2)
      ),
      // cellClassName: classes.ASkCell
    },
    
    { field: 'FL_TABLE_PER', headerName: 'Table(%)', width: 60 },
    { field: 'FL_DEPTH_PER', headerName: 'Depth(%)', width: 60 },
    { field: 'FL_MEASUREMENTS', headerName: 'Measurement', width: 100 },
    { field: 'CUT', headerName: 'Cut', width: 50 },
    { field: 'POLISH', headerName: 'Polish', width: 50 },
    { field: 'SYMM', headerName: 'Symm', width: 50 },
    {
          field: 'Image',
          headerName: 'Image',
          width: 60,
          renderCell: (params) => (
            <Link
              component="button"
              onClick={(e)=>{e.stopPropagation();window.open(`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`);
            }}
            href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/${params.row.STONE}/still.jpg`}
              target="_blank"
            >
              Image
            </Link>
          ),
        },
        {
          field: 'Video',
          headerName: 'Video',
          width: 60,
          renderCell: (params) => (
            <Link
            onClick={(e)=>{e.stopPropagation();window.open(`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`);
          }}
              component="button"
              href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`}
              target="_blank"
            >
              Video
            </Link>
          ),
        },
      ];
  // const fetchStoneresultdata = useCallback(() => {
  //   !Boolean(id)?  setSearchData(searchid):setSearchData(id)
  //   jwtAuthAxios.get(`search/search-result/${!Boolean(id)? searchid:id}`).then((res) => {
  //     setStoneresultdata(res.data.data)
  //   }).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  //   jwtAuthAxios.get(`master/helper?party=1`).then((res) => {
  //     setUserParty(res.data?.data?.PARTY || [])
  //   }).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  // }, [SearchData])
  const AddtoBasketHandler = useCallback(() => {
    setBLOADER(true);
    // if (userSelectedParty) {
      jwtAuthAxios.post(`user/userbasket`, { "stone_id": SelectedStone,type:'I',stype:'POLISH-SINGLE' }).then((res) => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        navigate('/basket')
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        })
      }).finally(() => setBLOADER(false));
    // } else{
    //   swal.fire({
    //     icon: 'error',
    //     text: 'Please Select Party',
    //   })
    // }
  }, [SelectedStone])

  useEffect(async(n)=>{
    // console.log('SelectedStone',SelectedStone);
    let Data = await Stoneresultdata?.filter(s => SelectedStone?.includes(s.STONE))
    setSelectedStoneData(Data)
  },[SelectedStone])
    useEffect(() => {
      // console.log('SelectedStone',SelectedStoneData);
      if(SelectedStone && Stoneresultdata){let ndata = SelectedStone?.flatMap((stone) =>
        Stoneresultdata.filter((s) => s.STONE === stone)
      );
      // console.log(ndata);
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0 }
      ndata?.forEach(sdata => {
        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + sdata.CARATS,
          rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
          disc: Number(tempCal.disc) + Number(sdata.ASK_DISC),
          Gdisc: Number(tempCal.disc) + Number(sdata.GREEN_DISC),
          Rdisc: Number(tempCal.disc) + Number(sdata.RED_DISC),
        }
      });
      tempCal = {
        pcs: tempCal.pcs,
        cts: tempCal.cts,
        rap: Number(tempCal.rap) / Number(tempCal.pcs),
        disc: Number(tempCal.disc) / Number(tempCal.pcs),
        // Gdisc: Number(tempCal.Gdisc) / Number(tempCal.pcs),
        // Rdisc: Number(tempCal.Rdisc) / Number(tempCal.pcs),
      }
      tempCal = {
        ...tempCal,
        price: Number(tempCal.rap) - (tempCal.rap * tempCal.disc / 100),
        // Gprice: Number(tempCal.rap) - (tempCal.rap * tempCal.Gdisc / 100),
        // Rprice: Number(tempCal.rap) - (tempCal.rap * tempCal.Rdisc / 100)
      }
      // console.log(tempCal);
      tempCal.pcs != 0 && setSelectedStoneDetails({ ...tempCal, amt: tempCal.price * tempCal.cts,
        // Gamt: tempCal.Gprice * tempCal.cts,Ramt: tempCal.Rprice * tempCal.cts 
      })}
  
  },[SelectedStoneData])

const expoertoMail=async()=>{
  await jwtAuthAxios.post('mail/sendExcelmail', searchForm).then(res => {
    if (res.data.status === "success") {
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
    } else {
      swal.fire({
        icon: 'error',
        text: res.data.message ||'Something Went Wrong',
      });
    }
  }).catch(e=>{
    swal.fire({
      icon: 'error',
      text: 'Internal Server Error',
    });
  })
}

  // useEffect(() => {
  //   fetchStoneresultdata();
  // }, []);

  
  return (
    <div>
      <Grid container justifyContent={'end'}>
        <Grid item lg={3}>
        {/* {isMobile?<Tooltip  title={`Modify Search (${Stoneresultdata?.length})`}><Fab variant="contained" size='small' color='primary' disabled={!data?.length > 0} onClick={()=>fallBack(false)}><FilterAltIcon /> </Fab></Tooltip>:''} */}
        {!isMobile ?<Button onClick={()=>fallBack(false)} variant="outlined" startIcon={<FilterAltIcon  fontSize={'30px'} />}  color='primary'>Modify Search ({Stoneresultdata?.length})</Button>:<Tooltip  title={`Modify Search (${Stoneresultdata?.length})`}><Fab variant="contained" sx={{mr:1}} size='small' color='primary' disabled={!data?.length > 0} onClick={()=>fallBack(false)}><FilterAltIcon /> </Fab></Tooltip>}
        </Grid>
        <Grid item lg={9} sx={{ mb: 3, justifyContent: 'end' }} justifyContent={'end'}>
          {/* {Array.isArray(userParty) && */}
          <Stack direction={'row'} style={{ justifyContent: 'end' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}>
              <ExcelGenerate  text={'Excel'} data={SelectedStoneData} />
              {/* <ExcelGenerateForSearch  data={SelectedStoneData} /> */}
              {/* <FormControl sx={{ m: 1, minWidth: 350, justifyContent: 'end' }} size="small">
                <InputLabel id="demo-select-small">Party</InputLabel>
                <Select
                  labelId="demo-select-small"

                  label="Party"
                  onChange={(event) => setUserSelectedParty(event.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {userParty.map((party) => <MenuItem value={party.FL_PARTY_CODE}>{party.FL_PARTY_NAME}</MenuItem>)}
                </Select>
              </FormControl> */}
            {/* {Array.isArray(userParty) && <Autocomplete
                disablePortal
                id="combo-box-demo"
                value={(option) => option.FL_PARTY_CODE}
                getOptionLabel={(option) => option.FL_PARTY_NAME}
                options={userParty}
                sx={{width: 300}}
                onChange={(e)=>console.log(e.target.value)}
                renderInput={(params) => <TextField {...params} label="Select Party"/>}
            />} */}
           {isMobile ?<> <Tooltip title="Expoert To Mail"><Fab variant="contained" size='small' disabled={!SearchData.length > 0} onClick={expoertoMail} sx={{ display: 'flex', margin: '0 0px 22px auto' }} color="primary"><Email />
            </Fab></Tooltip>
           <Tooltip title="Add To Basket"><Fab variant="contained" size='small' disabled={!SearchData.length > 0} onClick={AddtoBasketHandler} sx={{ display: 'flex', margin: '0 0px 22px auto' }} color="primary"><ShoppingCartCheckoutSharpIcon />
            </Fab></Tooltip>
           </> :<><LoadingButton variant="contained" disabled={!SearchData.length > 0 
            } onClick={expoertoMail} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<Email />} color="primary">
              Expoert To Mail
            </LoadingButton>
            <LoadingButton loading={BLOADER} variant="contained" disabled={!SelectedStone.length > 0 
            } onClick={AddtoBasketHandler} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<ShoppingCartCheckoutSharpIcon />} color="primary">
              Add To Basket
            </LoadingButton></>}
          </Stack>
            {/* } */}
        </Grid>
      </Grid>
      <Paper>
        <div style={{height:'80vh'}}>
      {Stoneresultdata== null? <TableSkeleton cols={22} row={11}/>:Stoneresultdata.length >0 ?<DataGrid
        rows={Stoneresultdata || []}
        columns={columns}
        pageSize={rowsPerPage}
        page={page}
        checkboxSelection
        rowSelectionModel={SelectedStone}
        onRowSelectionModelChange={(n)=>setSelectedStone(n)}
        density='compact'
        getRowId={(row) => row.STONE}
        onPageChange={newPage=>setPage(newPage)}
        rowsPerPageOptions={[50, 100, 500]}
        rowCount={(Stoneresultdata && Stoneresultdata.length) || 0}
        pagination
        // autoHeight
        // stickySelectionToolbar
        // disableRowSelectionOnClick

        stickyHeader
      />: <NoDataPlaceholder/>} </div></Paper>
      {/* <StoneTableViewWIthAGRFormat Stoneresultdata={Stoneresultdata} setStoneresultdata={setStoneresultdata} selectedStoneDetails={selectedStoneDetails} SelectedStone={SelectedStone} setSelectedStone={setSelectedStone} /> */}
    </div>
  );
}